
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import config from "@/config";
import { pageViewUnit } from "@/config";
@Component({
	name: "Inform"
})
export default class Inform extends Vue {
	@Action("policy/getInformData") private getInformData: any;
	@Action("policy/addInformPageView") private addPageView: any;
	pageViewUnit = pageViewUnit;
	show: Boolean = false;
	pageData = {};
	publicy = [];
	file: any = [];
	policy = [];
	informId: any = this.$route.query.informId;
	toPolicy({ id: informId }: any) {
		this.$router.push({
			path: "/detail/policy",
			query: { informId }
		});
	}
	created() {
		this.addPageView(this.informId);
		this.getData();
	}
	download({ url }: any) {
		window.open(url);
	}
	getData() {
		const loading = this.$loading({
			lock: true,
			text: "Loading",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)"
		});
		setTimeout(() => {
			loading && loading.close();
		}, 30000);
		this.getInformData(this.informId).then(({ code, data, msg }: any) => {
			if (code === 0) {
				loading && loading.close();
				const {
					department,
					releaseDate,
					title,
					content,
					policies,
					pageView,
					enclosureVoList
				} = data;
				const branch = department.departmentName;
				this.policy = policies ? policies : [];
				this.pageData = { branch, releaseDate, title, content, pageView };
				this.file = enclosureVoList.map(
					({ enclosureName, enclosureUrl }: any) => {
						const name = enclosureName.split("-")[
							enclosureName.split("-").length - 1
						];
						const baseURL =
							process.env.NODE_ENV === "development"
								? config.basicUrl
								: `${location.origin}/`;
						const url = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
							enclosureUrl
						)}`;
						return { name, url };
					}
				);
				return data;
			}
		});
	}
}
